export type Order = 'asc' | 'desc';

export interface TableHeaderData {
  text: string;
  key: string;
}

export const DetectorResendSortedTableFields: {[n: string]: TableHeaderData} = {
  fromDate: {
    text: 'From Date',
    key: 'from_date',
  },
  detections: {
    text: 'detections',
    key: 'detections',
  },
  resends: {
    text: 'resends',
    key: 'resends',
  },
  avgRssi: {
    text: 'Average RSSI',
    key: 'average_rssi',
  },
  avgResend: {
    text: 'Avg Resend',
    key: 'avg_resend_counter',
  },
  maxResend: {
    text: 'Max Resend',
    key: 'max_resend_counter',
  },
  score: {
    text: 'Score',
    key: 'score',
  },
  category: {
    text: 'Category',
    key: 'category',
  },
};


export const TramResendSortedTableFields: {[n: string]: TableHeaderData} = {
  train: {
    text: 'Train',
    key: 'train_number',
  },
  model: {
    text: 'Model',
    key: 'model_number',
  },
  avgRssi: {
    text: 'Avg Rssi',
    key: 'avg_rssi',
  },
  trend: {
    text: 'Trend',
    key: 'trend',
  },
  resendRate: {
    text: 'Resend Rate %',
    key: 'resend_rate',
  },
  resendSpikes: {
    text: 'Resent Spikes',
    key: 'resent_spikes',
  },
  worstDetector: {
    text: 'Worst Detector',
    key: 'worst_detector',
  },
  detWithoutFlag: {
    text: 'det:WithoutFlag',
    key: 'trips_without_resend_flag',
  },
  detWithFlag: {
    text: 'det:WithFlag',
    key: 'trips_with_resend_flag',
  },
  resendsPerDetector: {
    text: 'ResendsPerDetector',
    key: 'resends_per_detector',
  },
  score: {
    text: 'Score',
    key: 'problem_score',
  },
  category: {
    text: 'Category',
    key: 'category',
  },
};

export function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  let leftValue: T[keyof T];
  let rightValue: T[keyof T];

  if (a) {
    leftValue = b[orderBy];
    rightValue = a[orderBy];
  } else {
    leftValue = b[orderBy];
    rightValue = a[orderBy];
  }

  if (!leftValue) return -1;
  if (!rightValue) return 1;

  if (orderBy === DetectorResendSortedTableFields.category.key) {
    const codeObj = {
      "High Risk": 1,
      "Moderate": 0,
      "Safe": -1
    }
    return codeObj[leftValue.label] - codeObj[rightValue.label];
  }

  if (orderBy === DetectorResendSortedTableFields.fromDate.key) {
    leftValue = new Date(leftValue);
    rightValue = new Date(rightValue);
  }

  if (leftValue < rightValue) {
    return -1;
  }
  if (leftValue > rightValue) {
    return 1;
  }

  return 0;
}



export function tramDescendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  let leftValue: T[keyof T];
  let rightValue: T[keyof T];

  if(orderBy === TramResendSortedTableFields.model.key) {
     if(a.model_number === "N/A" ) {
       return -1;
     }

    if(b.model_number === "N/A" ) {
      return 1;
    }

    leftValue = a.model_number.substring(1, a.model_number.length);
    rightValue = b.model_number.substring(1, b.model_number.length);
    return parseInt(leftValue, 10) > parseInt(rightValue, 10) ? 1 : 0;
  }

  if(orderBy === TramResendSortedTableFields.model.key) {
    if(a.model_number === "N/A" ) {
      return -1;
    }

    if(b.model_number === "N/A" ) {
      return 1;
    }

    leftValue = a.model_number.substring(1, a.model_number.length);
    rightValue = b.model_number.substring(1, b.model_number.length);
    return parseInt(leftValue, 10) > parseInt(rightValue, 10) ? 1 : 0;
  }

  if(orderBy === TramResendSortedTableFields.train.key) {
    leftValue = a.train_number;
    rightValue = b.train_number;
    return parseInt(leftValue, 10) > parseInt(rightValue, 10) ? 1 : -1;
  }

  if(orderBy === TramResendSortedTableFields.score.key) {
    leftValue = a.problem_score;
    rightValue = b.problem_score;
    return parseInt(leftValue, 10) > parseInt(rightValue, 10) ? 1 : -1;
  }


  if (a) {
    leftValue = b[orderBy];
    rightValue = a[orderBy];
  } else {
    leftValue = b[orderBy];
    rightValue = a[orderBy];
  }

  if (!leftValue) return -1;
  if (!rightValue) return 1;

  if (orderBy === TramResendSortedTableFields.category.key) {
    const codeObj = {
      "High Risk": 1,
      "Moderate": 0,
      "Safe": -1
    }
    return codeObj[leftValue.label] - codeObj[rightValue.label];
  }

  if (leftValue < rightValue) {
    return -1;
  }
  if (leftValue > rightValue) {
    return 1;
  }

  return 0;
}


export function getComparator<Key extends keyof never>(
  order: Order,
  orderBy: Key,
): (a: {[key in Key]: number | string}, b: {[key in Key]: number | string}) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export function tramResendComparator<Key extends keyof never>(
  order: Order,
  orderBy: Key,
): (a: {[key in Key]: number | string}, b: {[key in Key]: number | string}) => number {
  return order === 'desc'
    ? (a, b) => tramDescendingComparator(a, b, orderBy)
    : (a, b) => -tramDescendingComparator(a, b, orderBy);
}
